import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import * as DTOS from "../../../../FeralScan.dtos";
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as DataActionCreators from "../../../../actions/data.actions";
import { withTheme } from '../../../../common/withTheme';
import Loader from 'react-loaders';
import FileUploadOnSubmit from '../../../Data/FileDropZone/FileUploadOnSubmit';

type PageAdminImportsProps = {
    theme?: string;
}

type PageAdminImportsActions = {
}

type PageAdminImportsRouteParams = {
    plotId: string;
}

type PageAdminImportsQueryParams = {
    userId: string;
}

type PageAdminImportsPropsMapped = {
    plot: DTOS.Plot;
    plotLoading: boolean;
    user: DTOS.User;
    userLoading: boolean;
    importProcessing: boolean;
    importResponse: any;// DTOS.AdminBatchImportResponse;
}

type PageAdminImportsActionsMapped = {
    batchAdminImport: typeof AdminActionCreators.batchImportRequest;
    batchAdminImportClearError: typeof AdminActionCreators.batchImportClearError;
    getSinglePlot: typeof DataActionCreators.getSinglePlotRequest;
    getSingleUser: typeof AdminActionCreators.getSingleUserRequest;
}

type PageAdminImportsAllPropsInherited = PageAdminImportsProps & PageAdminImportsActions;
type PageAdminImportsAllPropsMapped = PageAdminImportsPropsMapped & PageAdminImportsActionsMapped;

type PageAdminImportsAllProps = IBasePageProps<PageAdminImportsRouteParams, PageAdminImportsQueryParams> & Partial<PageAdminImportsAllPropsMapped> & PageAdminImportsAllPropsInherited;

interface IPageAdminImportsState {
    files: any[]
}

class PageAdminImports extends React.Component<PageAdminImportsAllProps, IPageAdminImportsState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            files: []
        }
    }

    componentDidMount() {
        this.props.batchAdminImportClearError();

        if (this.props.routeParams.plotId) {
            const plotId = Number(this.props.routeParams.plotId)
            this.props.getSinglePlot(plotId)
        }

        if (this.props.queryParams.userId) {
            const userId = Number(this.props.queryParams.userId)
            this.props.getSingleUser(userId)
        }
    }

    onClearFilesAndErrors() {
        this.props.batchAdminImportClearError();
        this.setState({
            files: undefined
        });
    }

    onSubmit() {
        const plotId = this.props.routeParams.plotId ? Number(this.props.routeParams.plotId) : undefined;
        const userId = this.props.queryParams.userId ? Number(this.props.queryParams.userId) : undefined;

        if (plotId && userId) {
            this.props.batchAdminImport(this.state.files, plotId, userId);
        } else {

        }
    }

    onDrop(files) {
        this.setState({ files });
    }

    onCancel() {
        this.setState({
            files: []
        });
    }

    render() {

        const { importProcessing, importResponse, plot, user } = this.props;

        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            {
                <div className="col-12 pb-2 border-bottom">
                    <div className="form-group row">
                        <label className="col-md-1 col-form-label">Site:</label>
                        <div className="col-md-10">
                            <input className="form-control" disabled value={plot ? plot.name : ''} />
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-md-1 col-form-label">User:</label>
                        <div className="col-md-10">
                            <input className="form-control" disabled value={user ? user.fullName : ''} />
                        </div>
                    </div>
                    <div className="my-3 border d-flex flex-row">
                        <span><i className="fa fa-info-circle p-3" />Upload one or more CSV format files with columns PlatypusSeen and ScanDateTime.</span>
                    </div>
                </div>
            }
            {
                importResponse ?
                    <div className="col-12 mt-5 text-center">
                        {
                            importResponse.responseStatus
                                ? <div><h3 className="alert alert-danger">Import failed: {importResponse.responseStatus.message}</h3><p className="alert alert-dark">{importResponse.responseStatus.stackTrace}</p></div>
                                : <h3>Successfully imported {importResponse.importedCount} {importResponse.importedCount === 1 ? 'record' : 'records'}.</h3>
                        }
                        <button className="btn btn-primary btn-lg" onClick={this.onClearFilesAndErrors.bind(this)}>
                            Upload another file
                        </button>
                    </div>
                    : !importProcessing ?
                        <div className="col-12">
                            <FileUploadOnSubmit 
                                files={this.state.files}
                                maxFiles={1}
                                onCancel={() => this.onCancel()}
                                onDrop={(files) => this.onDrop(files)}
                                onSubmit={() => this.onSubmit()}
                                uploadText={"IMPORT"}
                            />
                        </div>
                        : <div className="col-12 mt-5 d-flex flex-column align-items-center">
                            <Loader type="line-scale" active />
                            <div className="">Uploading</div>
                        </div>
            }
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminImportsAllProps): PageAdminImportsPropsMapped => {

    const plot = state.data.plots ? state.data.plots.find(p => p.id === Number(ownProps.routeParams.plotId)) : undefined;
    const user = state.admin.users ? state.admin.users.find(u => u.id === Number(ownProps.queryParams.userId)) : undefined;

    return {
        plot: plot,
        plotLoading: state.data.plotLoading,
        user: user,
        userLoading: state.admin.usersLoading,
        importProcessing: state.admin.batchImportProcessing,
        importResponse: state.admin.batchImportReponse
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminImportsActionsMapped>({
        batchAdminImport: AdminActionCreators.batchImportRequest,
        batchAdminImportClearError: AdminActionCreators.batchImportClearError,
        getSinglePlot: DataActionCreators.getSinglePlotRequest,
        getSingleUser: AdminActionCreators.getSingleUserRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<PageAdminImportsAllProps>(PageAdminImports));